var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 302.71 232.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.41,232.85a11.73,11.73,0,0,1,0-23.45l104.87.17a93.15,93.15,0,0,0,0-186.29l-174.55.17A11.73,11.73,0,1,1,11.73,0H186.3a116.4,116.4,0,1,1,0,232.8ZM218,147.9a31.5,31.5,0,1,1,31.49-31.5A31.5,31.5,0,0,1,218,147.9ZM186.28,58.22A11.68,11.68,0,0,1,174.6,69.9H62.88a11.68,11.68,0,0,1,0-23.35H174.6A11.67,11.67,0,0,1,186.28,58.22ZM163,116.45a11.68,11.68,0,0,1-11.68,11.68H11.68a11.68,11.68,0,1,1,0-23.36H151.32A11.68,11.68,0,0,1,163,116.45Zm23.28,58.2a11.67,11.67,0,0,1-11.68,11.67H35A11.68,11.68,0,0,1,35,163H174.6A11.68,11.68,0,0,1,186.28,174.65Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsoWhite);
export default __webpack_public_path__ + "static/media/iso-white.6829f00416d30bc732a17a1612bfa790.svg";
export { ForwardRef as ReactComponent };